import { render, staticRenderFns } from "./ImportExams.vue?vue&type=template&id=10a70ff4"
import script from "./ImportExams.vue?vue&type=script&lang=js"
export * from "./ImportExams.vue?vue&type=script&lang=js"
import style0 from "./ImportExams.vue?vue&type=style&index=0&id=10a70ff4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports